var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "section-posts",
      class: [{ planner: _vm.activeSection == "calendar" }],
    },
    [
      _vm.showLoader
        ? _c(
            "div",
            [
              _c("component-loader", {
                attrs: { progress: _vm.percentLoader, activeClose: true },
                on: {
                  close: function ($event) {
                    _vm.showLoader = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "pages-sidebar",
          class: { contract: _vm.tabsIsMinimize },
        },
        [
          _c(
            "div",
            { staticClass: "table-title", on: { click: _vm.toggleExpandTabs } },
            [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      _vm.activeSection == "tab"
                        ? "dash.posts.title"
                        : "dash.tab.scheduler"
                    )
                  )
                ),
              ]),
            ]
          ),
          _c("div", { staticClass: "show-setting" }, [
            !_vm.tabsIsMinimize
              ? _c(
                  "i",
                  {
                    staticClass: "material-icons expand-btn minimize",
                    on: { click: _vm.toggleExpandTabs },
                  },
                  [_vm._v("navigate_before")]
                )
              : _vm._e(),
            _vm.tabsIsMinimize
              ? _c(
                  "i",
                  {
                    staticClass: "material-icons expand-btn maximize",
                    on: { click: _vm.toggleExpandTabs },
                  },
                  [_vm._v("navigate_next")]
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "search-page" },
            [
              _c("vs-input", {
                staticClass: "inputx",
                class: { input: true },
                attrs: {
                  color: "#B20564",
                  "icon-after": "true",
                  icon: "search",
                  placeholder: _vm.$t("dash.settings.user.label.page_filter"),
                },
                model: {
                  value: _vm.pageFilter,
                  callback: function ($$v) {
                    _vm.pageFilter = $$v
                  },
                  expression: "pageFilter",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "filter-selected" },
            [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      _vm.filterSelected = !_vm.filterSelected
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        !_vm.filterSelected
                          ? `dash.pages-sidebar.filter-selected${
                              _vm.selectedPages.length > 1 ? "-multi" : ""
                            }`
                          : "dash.pages-sidebar.filter-all"
                      )
                    )
                  ),
                ]
              ),
              _c(
                "Tooltip",
                {
                  attrs: {
                    text: _vm.$t(
                      !_vm.selectAllPages
                        ? `dash.pages-sidebar.cta-select-all`
                        : "dash.pages-sidebar.cta-unselect-all"
                    ),
                    position: "top",
                  },
                },
                [
                  !_vm.selectAllPages
                    ? _c("img", {
                        attrs: {
                          alt: "Select all pages",
                          src: require("../../../assets/img/select_all_icon.svg"),
                        },
                        on: {
                          click: function ($event) {
                            _vm.selectAllPages = !_vm.selectAllPages
                          },
                        },
                      })
                    : _c("img", {
                        attrs: {
                          alt: "Unselect pages",
                          src: require("../../../assets/img/unselect_icon.svg"),
                        },
                        on: {
                          click: function ($event) {
                            _vm.selectAllPages = !_vm.selectAllPages
                          },
                        },
                      }),
                  _vm._v("\n         \n      "),
                ]
              ),
            ],
            1
          ),
          _vm.groups && _vm.posts
            ? _c(
                "ul",
                [
                  _vm._l(_vm.groups, function (group) {
                    return _c(
                      "li",
                      {
                        key: group.id,
                        staticClass: "group",
                        class: [
                          {
                            show: group.show,
                            hide:
                              !_vm.checkPagesInGroup(group) ||
                              _vm.checkGroupFilter(group),
                          },
                        ],
                      },
                      [
                        _c("div", { staticClass: "group-wrapper" }, [
                          !group.show
                            ? _c("img", {
                                staticClass: "show-group",
                                attrs: {
                                  alt: "show group",
                                  src: require("../../../assets/img/icon-show-group.svg"),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleShowGroup(group)
                                  },
                                },
                              })
                            : _c("img", {
                                staticClass: "hide-group",
                                attrs: {
                                  alt: "hide group",
                                  src: require("../../../assets/img/icon-hide-group.svg"),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleShowGroup(group)
                                  },
                                },
                              }),
                          _c(
                            "div",
                            { staticClass: "group-content" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: { text: group.name, position: "top" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "group-name messagedefilant",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { "data-text": group.name } },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(group.name)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v("\n               \n            "),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedGroups,
                                  expression: "selectedGroups",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                id: `groups-${group.id}`,
                                name: "groups[]",
                              },
                              domProps: {
                                value: group.id,
                                checked: Array.isArray(_vm.selectedGroups)
                                  ? _vm._i(_vm.selectedGroups, group.id) > -1
                                  : _vm.selectedGroups,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.selectedGroups,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = group.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.selectedGroups = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.selectedGroups = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.selectedGroups = $$c
                                    }
                                  },
                                  function ($event) {
                                    return _vm.checkGroup(group)
                                  },
                                ],
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "checkmark",
                                class: [
                                  {
                                    deselect:
                                      _vm.checkAllPagesGroupSelected(group),
                                  },
                                ],
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    alt: "checkup",
                                    src: require("../../../assets/img/icon-checkup.svg"),
                                  },
                                }),
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("remove"),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                        _c(
                          "ul",
                          _vm._l(group.pages, function (item) {
                            return _c("div", { key: item }, [
                              _vm.findPage(item)
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "page",
                                      class: [
                                        {
                                          disabled:
                                            !_vm.checkLock(
                                              _vm.findPage(item).network
                                            ) ||
                                            (!_vm.isUserPremiumActive &&
                                              _vm.posts[0].pages.id !==
                                                _vm.findPage(item).id &&
                                              !_vm.isUserPartner),
                                          hide:
                                            !_vm.checkPageFilter(
                                              _vm.findPage(item)
                                            ) ||
                                            _vm.pageWithoutBot(
                                              _vm.findPage(item)
                                            ) ||
                                            !_vm.checkSelected(
                                              _vm.findPage(item)
                                            ),
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "page-wrapper",
                                          class: {
                                            disabled: !_vm.checkLock(
                                              _vm.findPage(item).network
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "checkbox" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.selectedPages,
                                                    expression: "selectedPages",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id: `pages-${
                                                    _vm.findPage(item).id
                                                  }`,
                                                  name: "pages[]",
                                                  "data-qa": `posts-selector-list-page-${
                                                    _vm.findPage(item).name
                                                  }`,
                                                  disabled:
                                                    !_vm.checkLock(
                                                      _vm.findPage(item).network
                                                    ) ||
                                                    (!_vm.isUserPremiumActive &&
                                                      _vm.posts[0].pages.id !==
                                                        _vm.findPage(item).id &&
                                                      !_vm.isUserPartner),
                                                },
                                                domProps: {
                                                  value: _vm.findPage(item),
                                                  checked: Array.isArray(
                                                    _vm.selectedPages
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectedPages,
                                                        _vm.findPage(item)
                                                      ) > -1
                                                    : _vm.selectedPages,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = _vm.selectedPages,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v =
                                                          _vm.findPage(item),
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.selectedPages =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.selectedPages =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.selectedPages = $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._m(0, true),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "page-content" },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.findPage(item)
                                                      .name,
                                                    position: "top",
                                                  },
                                                },
                                                [
                                                  _c("page-image-avatar", {
                                                    attrs: {
                                                      page: _vm.findPage(item),
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "page-name messagedefilant",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            "data-text":
                                                              _vm.findPage(item)
                                                                .name,
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.findPage(
                                                                  item
                                                                ).name
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "\n                     \n                  "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                  _vm._l(_vm.posts, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: item.pages.id,
                        staticClass: "page",
                        class: [
                          {
                            current: _vm.selectedTab == index,
                            disabled:
                              !_vm.checkLock(item.pages.network) ||
                              (!_vm.isUserPremiumActive &&
                                _vm.posts[0].pages.id !== item.pages.id &&
                                !_vm.isUserPartner),
                            hide:
                              !_vm.checkPageFilter(item.pages) ||
                              _vm.pageInGroup(item.pages) ||
                              _vm.pageWithoutBot(item.pages) ||
                              !_vm.checkSelected(item.pages),
                          },
                        ],
                      },
                      [
                        !_vm.pageInGroup(item.pages)
                          ? _c(
                              "div",
                              {
                                staticClass: "page-wrapper",
                                class: {
                                  disabled:
                                    !_vm.checkLock(item.pages.network) ||
                                    (!_vm.isUserPremiumActive &&
                                      index != 0 &&
                                      !_vm.isUserPartner),
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "page-content" },
                                  [
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: item.pages.name,
                                          position: "top",
                                        },
                                      },
                                      [
                                        _c("page-image-avatar", {
                                          attrs: { page: item.pages },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "page-name messagedefilant",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: {
                                                  "data-text": item.pages.name,
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.pages.name)
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n               \n            "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedPages,
                                        expression: "selectedPages",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: `pages-${item.pages.id}`,
                                      name: "pages[]",
                                      "data-qa": `posts-selector-list-page-${item.pages.name}`,
                                      disabled:
                                        !_vm.checkLock(item.pages.network) ||
                                        (!_vm.isUserPremiumActive &&
                                          _vm.posts[0].pages.id !==
                                            item.pages.id &&
                                          !_vm.isUserPartner),
                                    },
                                    domProps: {
                                      value: item.pages,
                                      checked: Array.isArray(_vm.selectedPages)
                                        ? _vm._i(
                                            _vm.selectedPages,
                                            item.pages
                                          ) > -1
                                        : _vm.selectedPages,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.selectedPages,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = item.pages,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedPages = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedPages = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedPages = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._m(1, true),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "filters-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "filter",
            class: { active: _vm.filter.includes("all") },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter,
                  expression: "filter",
                },
              ],
              attrs: {
                type: "checkbox",
                name: "content",
                value: "all",
                "data-qa": "posts-filter-all",
                disabled: _vm.filter.includes("all"),
              },
              domProps: {
                checked: Array.isArray(_vm.filter)
                  ? _vm._i(_vm.filter, "all") > -1
                  : _vm.filter,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.filter,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = "all",
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.filter = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.filter = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.filter = $$c
                    }
                  },
                  function ($event) {
                    ;[(_vm.filter = ["all"]), _vm.arrayPostsFilter(false)]
                  },
                ],
              },
            }),
            _c("div", { staticClass: "filter-content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.status.all")))]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "filter",
            class: { active: _vm.filter.includes("draft") },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter,
                  expression: "filter",
                },
              ],
              attrs: {
                type: "checkbox",
                name: "content",
                value: "draft",
                "data-qa": "posts-filter-draft",
                disabled:
                  _vm.filter.length == 1 && _vm.filter.includes("draft"),
              },
              domProps: {
                checked: Array.isArray(_vm.filter)
                  ? _vm._i(_vm.filter, "draft") > -1
                  : _vm.filter,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.filter,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = "draft",
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.filter = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.filter = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.filter = $$c
                    }
                  },
                  function ($event) {
                    ;[
                      (_vm.filter = _vm.filter.filter((f) => f != "all")),
                      _vm.arrayPostsFilter(false),
                    ]
                  },
                ],
              },
            }),
            _c("div", { staticClass: "filter-content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.status.draft")))]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "filter",
            class: { active: _vm.filter.includes("queue") },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter,
                  expression: "filter",
                },
              ],
              attrs: {
                type: "checkbox",
                name: "content",
                value: "queue",
                "data-qa": "posts-filter-queue",
                disabled:
                  _vm.filter.length == 1 && _vm.filter.includes("queue"),
              },
              domProps: {
                checked: Array.isArray(_vm.filter)
                  ? _vm._i(_vm.filter, "queue") > -1
                  : _vm.filter,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.filter,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = "queue",
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.filter = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.filter = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.filter = $$c
                    }
                  },
                  function ($event) {
                    ;[
                      (_vm.filter = _vm.filter.filter((f) => f != "all")),
                      _vm.arrayPostsFilter(false),
                    ]
                  },
                ],
              },
            }),
            _c("div", { staticClass: "filter-content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.status.inqueue")))]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "filter",
            class: { active: _vm.filter.includes("scheduled") },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter,
                  expression: "filter",
                },
              ],
              attrs: {
                type: "checkbox",
                name: "content",
                value: "scheduled",
                "data-qa": "posts-filter-scheduled",
                disabled:
                  _vm.filter.length == 1 && _vm.filter.includes("scheduled"),
              },
              domProps: {
                checked: Array.isArray(_vm.filter)
                  ? _vm._i(_vm.filter, "scheduled") > -1
                  : _vm.filter,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.filter,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = "scheduled",
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.filter = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.filter = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.filter = $$c
                    }
                  },
                  function ($event) {
                    ;[
                      (_vm.filter = _vm.filter.filter((f) => f != "all")),
                      _vm.arrayPostsFilter(false),
                    ]
                  },
                ],
              },
            }),
            _c("div", { staticClass: "filter-content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.status.scheduled")))]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "filter",
            class: { active: _vm.filter.includes("posted") },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter,
                  expression: "filter",
                },
              ],
              attrs: {
                type: "checkbox",
                name: "content",
                value: "posted",
                "data-qa": "posts-filter-posted",
                disabled:
                  _vm.filter.length == 1 && _vm.filter.includes("posted"),
              },
              domProps: {
                checked: Array.isArray(_vm.filter)
                  ? _vm._i(_vm.filter, "posted") > -1
                  : _vm.filter,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.filter,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = "posted",
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.filter = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.filter = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.filter = $$c
                    }
                  },
                  function ($event) {
                    ;[
                      (_vm.filter = _vm.filter.filter((f) => f != "all")),
                      _vm.arrayPostsFilter(false),
                    ]
                  },
                ],
              },
            }),
            _c("div", { staticClass: "filter-content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.status.posted")))]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "filter",
            class: { active: _vm.filter.includes("failed") },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter,
                  expression: "filter",
                },
              ],
              attrs: {
                type: "checkbox",
                name: "content",
                value: "failed",
                "data-qa": "posts-filter-failed",
                disabled:
                  _vm.filter.length == 1 && _vm.filter.includes("failed"),
              },
              domProps: {
                checked: Array.isArray(_vm.filter)
                  ? _vm._i(_vm.filter, "failed") > -1
                  : _vm.filter,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.filter,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = "failed",
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.filter = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.filter = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.filter = $$c
                    }
                  },
                  function ($event) {
                    ;[
                      (_vm.filter = _vm.filter.filter((f) => f != "all")),
                      _vm.arrayPostsFilter(false),
                    ]
                  },
                ],
              },
            }),
            _c("div", { staticClass: "filter-content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.status.failed")))]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "filter",
            class: { active: _vm.filter.includes("removed") },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter,
                  expression: "filter",
                },
              ],
              attrs: {
                type: "checkbox",
                name: "content",
                value: "removed",
                "data-qa": "posts-filter-removed",
                disabled:
                  _vm.filter.length == 1 && _vm.filter.includes("removed"),
              },
              domProps: {
                checked: Array.isArray(_vm.filter)
                  ? _vm._i(_vm.filter, "removed") > -1
                  : _vm.filter,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.filter,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = "removed",
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.filter = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.filter = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.filter = $$c
                    }
                  },
                  function ($event) {
                    ;[
                      (_vm.filter = _vm.filter.filter((f) => f != "all")),
                      _vm.arrayPostsFilter(false),
                    ]
                  },
                ],
              },
            }),
            _c("div", { staticClass: "filter-content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.status.removed")))]),
            ]),
          ]
        ),
        _vm.activeSection == "calendar" && _vm.activeSynchronized
          ? _c(
              "div",
              {
                staticClass: "filter",
                class: { active: _vm.filter.includes("direct") },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter,
                      expression: "filter",
                    },
                  ],
                  attrs: {
                    type: "checkbox",
                    name: "content",
                    value: "direct",
                    "data-qa": "posts-filter-direct",
                    disabled:
                      _vm.filter.length == 1 && _vm.filter.includes("direct"),
                  },
                  domProps: {
                    checked: Array.isArray(_vm.filter)
                      ? _vm._i(_vm.filter, "direct") > -1
                      : _vm.filter,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.filter,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "direct",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.filter = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.filter = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.filter = $$c
                        }
                      },
                      function ($event) {
                        ;[
                          (_vm.filter = _vm.filter.filter((f) => f != "all")),
                          _vm.arrayPostsFilter(false),
                        ]
                      },
                    ],
                  },
                }),
                _c("div", { staticClass: "filter-content" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("dash.post.direct")))]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _c(
        "vs-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showAdd,
              expression: "!showAdd",
            },
          ],
        },
        [
          _c(
            "vs-col",
            {
              attrs: {
                "vs-justify": "center",
                "vs-align": "center",
                "vs-w": "12",
              },
            },
            [
              ["Admin", "Editor", "Writter"].includes(_vm.getUserRole)
                ? _c(
                    "div",
                    { staticClass: "actions-wrapper" },
                    [
                      _vm.disableAddPost
                        ? _c(
                            "Tooltip",
                            {
                              staticStyle: { float: "left" },
                              attrs: {
                                text: _vm.$t("dash.bots.status_ko"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass: "add-btn btn-large btn-img",
                                  attrs: {
                                    color: "#303030",
                                    "vs-type": "filled",
                                    "data-qa": "open-manual-post",
                                    disabled: true,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.displayOverlay(true)
                                    },
                                  },
                                },
                                [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.$t("dash.posts.add"))),
                                  ]),
                                ]
                              ),
                              _vm._v("\n           \n        "),
                            ],
                            1
                          )
                        : _c(
                            "vs-button",
                            {
                              staticClass: "add-btn btn-large btn-img",
                              attrs: {
                                color: "#303030",
                                "vs-type": "filled",
                                "data-qa": "open-manual-post",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.displayOverlay(true)
                                },
                              },
                            },
                            [
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("dash.posts.add"))),
                              ]),
                            ]
                          ),
                      _c(
                        "div",
                        { staticClass: "frequency-wrapper" },
                        [
                          _c("vs-button", {
                            attrs: {
                              color: "primary",
                              type: "filled",
                              icon: "refresh",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.retrievePosts(
                                  _vm.selectedTab,
                                  _vm.linked[_vm.selectedTab].id,
                                  null,
                                  null,
                                  true
                                )
                              },
                            },
                          }),
                          _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.frequency.refresh"),
                                position: "top",
                              },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.refresh.frequency,
                                      expression: "refresh.frequency",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.refresh,
                                        "frequency",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.refresh.allowed,
                                  function (freq, key) {
                                    return _c(
                                      "option",
                                      {
                                        key: key,
                                        style: freq ? "" : "color: gray",
                                        domProps: { value: freq },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            freq
                                              ? freq + " sec"
                                              : _vm.$t("dash.posts.no_refresh")
                                          )
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _vm._v("\n             \n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.activeSection == "calendar"
                        ? _c(
                            "div",
                            {
                              staticClass: "share-planner synchronized",
                              class: [
                                { activeSynchronized: _vm.activeSynchronized },
                              ],
                              on: {
                                click: function ($event) {
                                  !_vm.activeSynchronized
                                    ? _vm.synchronizePosts()
                                    : null
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.loadSynchronisation
                                        ? `dash.planner.synchronized.inprogress`
                                        : `dash.planner.synchronized`
                                    )
                                  )
                                ),
                              ]),
                              _vm.loadSynchronisation
                                ? _c("component-loader", {
                                    attrs: {
                                      progress: 90,
                                      unlimitedProgress: true,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.activeSection == "calendar" &&
                      ["Admin", "Editor"].includes(_vm.getUserRole)
                        ? _c(
                            "div",
                            {
                              staticClass: "share-planner",
                              on: {
                                click: function ($event) {
                                  _vm.popupSharedPlanner = true
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t(`dash.planner.share_planner`))
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "vs-popup",
                        {
                          staticClass: "overlay groups shared-planner",
                          attrs: {
                            title: _vm.$t(
                              "dash.pages.group-shared-planner.overlay.title"
                            ),
                            active: _vm.popupSharedPlanner,
                          },
                          on: {
                            "update:active": function ($event) {
                              _vm.popupSharedPlanner = $event
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "edit-users",
                              on: {
                                click: function ($event) {
                                  return _vm.goToListUsers()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "dash.pages.group-shared-planner.overlay.edit"
                                  )
                                )
                              ),
                            ]
                          ),
                          _vm.popupSharedPlanner
                            ? _c("component-pages-selector", {
                                attrs: {
                                  groups: _vm.groups,
                                  type: "shared_planner",
                                  pagesAdded: _vm.selectedPages,
                                },
                                on: { submit: _vm.createSharedPlanner },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.popupUrlSharedPlanner
                        ? _c(
                            "vs-popup",
                            {
                              staticClass: "overlay groups shared-planner-url",
                              attrs: {
                                title: _vm.$t(
                                  "dash.pages.group-shared-planner.overlay.title"
                                ),
                                active: _vm.popupUrlSharedPlanner,
                              },
                              on: {
                                "update:active": function ($event) {
                                  _vm.popupUrlSharedPlanner = $event
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "link_to_copy",
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyUrlSharedPlanner()
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.urlSharedPlanner.substr(0, 50)
                                      ) + " ..."
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/copy_icon.svg"),
                                      alt: "unlock",
                                    },
                                  }),
                                ]
                              ),
                              _c("br"),
                              _c(
                                "vs-button",
                                {
                                  staticClass: "btnx",
                                  attrs: { type: "filled" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.copyUrlSharedPlanner()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("dash.button.copy")) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.activeExportImportFeatures &&
                      ["Admin", "Editor"].includes(_vm.getUserRole)
                        ? _c(
                            "div",
                            { staticClass: "export-import" },
                            [
                              _c(
                                "vs-button",
                                {
                                  staticClass: "btn-img",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      ;[
                                        (_vm.popupExport = true),
                                        (_vm.filterExport = _vm.filter =
                                          ["all"]),
                                        _vm.arrayPostsFilter(true),
                                      ]
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/ico-export.svg"),
                                      alt: "unlock",
                                    },
                                  }),
                                  _c("p", [_vm._v("Export")]),
                                ]
                              ),
                              _c(
                                "vs-button",
                                {
                                  staticClass: "btn-img",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      ;[
                                        (_vm.popupImport = true),
                                        (_vm.fileInput = _vm.fileInputParesed =
                                          []),
                                      ]
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/ico-import.svg"),
                                      alt: "unlock",
                                    },
                                  }),
                                  _c("p", [_vm._v("Import")]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c("div", { staticClass: "actions-wrapper right" }, [
                    _c(
                      "div",
                      { staticClass: "frequency-wrapper" },
                      [
                        _c("vs-button", {
                          attrs: {
                            color: "primary",
                            type: "filled",
                            icon: "refresh",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.retrievePosts(
                                _vm.selectedTab,
                                _vm.linked[_vm.selectedTab].id
                              )
                            },
                          },
                        }),
                        _c(
                          "Tooltip",
                          {
                            attrs: {
                              text: _vm.$t("dash.frequency.refresh"),
                              position: "top",
                            },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.refresh.frequency,
                                    expression: "refresh.frequency",
                                  },
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.refresh,
                                      "frequency",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(_vm.refresh.allowed, function (freq, key) {
                                return _c(
                                  "option",
                                  {
                                    key: key,
                                    style: freq ? "" : "color: gray",
                                    domProps: { value: freq },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        freq
                                          ? freq + " sec"
                                          : _vm.$t("dash.posts.no_refresh")
                                      )
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v("\n               \n            "),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
              _vm.selectedPages.length == 1
                ? _c(
                    "div",
                    { staticClass: "page-selected" },
                    [
                      _c("page-image-avatar", {
                        attrs: { page: _vm.selectedPages[0] },
                      }),
                      _c("p", { staticClass: "page-name" }, [
                        _vm._v(_vm._s(_vm.selectedPages[0].name)),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "page-selected" },
                    _vm._l(_vm.selectedPages, function (pageItem, pageIndex) {
                      return _c(
                        "Tooltip",
                        {
                          key: pageIndex,
                          attrs: { text: pageItem.name, position: "top" },
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.unselectPage(pageItem)
                                },
                              },
                            },
                            [
                              _c("page-image-avatar", {
                                attrs: { page: pageItem },
                              }),
                            ],
                            1
                          ),
                          _vm._v("\n           \n        "),
                        ]
                      )
                    }),
                    1
                  ),
              _c("div", { staticClass: "tables-wrapper" }, [
                _vm.activeSection == "calendar"
                  ? _c(
                      "div",
                      {
                        staticClass: "type-calendar",
                        on: { click: _vm.toggleTypeCalendar },
                      },
                      [
                        _vm.monthly
                          ? _c(
                              "Tooltip",
                              {
                                attrs: {
                                  text: _vm.$t(
                                    "dash.button.calendar_view_week"
                                  ),
                                  position: "top",
                                },
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "vs-icon notranslate icon-scale material-icons null",
                                  },
                                  [_vm._v("view_week")]
                                ),
                              ]
                            )
                          : _c(
                              "Tooltip",
                              {
                                attrs: {
                                  text: _vm.$t(
                                    "dash.button.calendar_view_month"
                                  ),
                                  position: "top",
                                },
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "vs-icon notranslate icon-scale material-icons null",
                                  },
                                  [_vm._v("today")]
                                ),
                              ]
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "tabs-content" }, [
                  _c(
                    "div",
                    { staticClass: "tab-content" },
                    [
                      _vm.activeSection == "tab" &&
                      _vm.listPosts &&
                      _vm.selectedPages.length
                        ? _c("component-customtables", {
                            key: "posts-table-" + _vm.filter + "-page-",
                            attrs: {
                              gridData: {
                                posts: _vm.listPosts,
                                pages: _vm.selectedPages[0],
                              },
                              page: _vm.selectedTab,
                              pages: _vm.selectedPages,
                              columns: _vm.columns,
                              filter: _vm.filter,
                              canUseCustomSources:
                                _vm.checkLock("source_choice"),
                              name: "posts",
                            },
                            on: {
                              edit: _vm.editPost,
                              post: _vm.editPost,
                              validate: _vm.add,
                              deleteScheduled: _vm.deleteScheduled,
                              excludeNews: _vm.excludeNews,
                              resharePost: _vm.resharePost,
                              retweetPost: _vm.retweetPost,
                              editDraft: _vm.editDraft,
                              openLoader: _vm.openLoader,
                              shareStory: _vm.shareToStory,
                              removeDrafts: _vm.removeDrafts,
                              duplicatePost: _vm.duplicatePost,
                            },
                          })
                        : _vm._e(),
                      _vm.activeSection == "calendar" &&
                      _vm.activePlanner &&
                      _vm.selectedPages.length
                        ? _c("component-posts-calendar", {
                            key: "calendar-table-" + _vm.filter + "-page-",
                            attrs: {
                              gridData: {
                                posts: _vm.listPosts,
                                calendar: _vm.weeklyPlanner,
                                monthlyCalendar: _vm.monthlyPlanner,
                                pages: _vm.selectedPages[0],
                              },
                              page: _vm.selectedTab,
                              pages: _vm.selectedPages,
                              columns: _vm.columns,
                              filter: _vm.filter,
                              canUseCustomSources:
                                _vm.checkLock("source_choice"),
                              isDeleteSlot: _vm.isDeleteSlot,
                              slotDate: _vm.slotDate,
                              slotBot: _vm.slotBot,
                              startDate: _vm.startDate,
                              openPostSidebar: _vm.openPostSidebar,
                              name: "posts-calendar",
                            },
                            on: {
                              edit: _vm.editPost,
                              post: _vm.editPost,
                              show: _vm.showPost,
                              add: _vm.addPost,
                              validate: _vm.add,
                              reload: _vm.reloadDataCalendar,
                              excludeNews: _vm.excludeNews,
                              deleteScheduled: _vm.deleteScheduled,
                              resetDeleteSot: _vm.resetDeleteSot,
                              processInsights: _vm.processInsights,
                              changeStartDate: _vm.changeStartDate,
                              resharePost: _vm.resharePost,
                              retweetPost: _vm.retweetPost,
                              editDraft: _vm.editDraft,
                              openLoader: _vm.openLoader,
                              shareStory: _vm.shareToStory,
                              removeDrafts: _vm.removeDrafts,
                              duplicatePost: _vm.duplicatePost,
                              validateDraft: _vm.validateDraft,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAdd,
              expression: "showAdd",
            },
          ],
        },
        [
          _vm.groups && !_vm.closePostsOverlay
            ? _c("component-posts-overlay", {
                ref: "postOvrelay",
                staticClass: "posts-form content",
                attrs: {
                  linked: _vm.linked,
                  content: _vm.popup.content,
                  bots: _vm.bots,
                  validated: _vm.popup.validated,
                  state: _vm.overlayState,
                  post: _vm.overlayItem,
                  page: _vm.overlayPage,
                  pages: _vm.overlayPages,
                  scheduledOverlay: _vm.scheduledOverlay,
                  showAdd: _vm.showAdd,
                  activeOptimalTimes: _vm.activeOptimalTimes,
                  recap: _vm.recap,
                  groupsCopy: _vm.groups,
                  storyShare: _vm.shareStory,
                  tabsIsMinimize: _vm.tabsIsMinimize,
                },
                on: {
                  add: _vm.add,
                  addWithoutBot: _vm.addWithoutBot,
                  update: _vm.update,
                  close: _vm.close,
                  deleteScheduled: _vm.deleteScheduled,
                  updateDrafts: _vm.filterPosts,
                  updatePages: _vm.filterPosts,
                  removeDrafts: _vm.removeDrafts,
                  setStoryShare: _vm.setStoryShare,
                  getPagesEvent: _vm.getListPages,
                  minimizeTabsEvent: _vm.minimizeTabsEvent,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.recap.length
        ? _c("component-posts-recap", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showAdd,
                expression: "!showAdd",
              },
            ],
            key: `postsRecap-${_vm.keyRecap}`,
            ref: "postsRecap",
            staticClass: "recap",
            attrs: {
              linked: _vm.linked,
              bots: _vm.bots,
              recap: _vm.recap,
              show: _vm.showRecap,
              totalPost: _vm.totalPost,
              countPost: _vm.countCurrentMultiplePosts,
            },
            on: {
              minimize: _vm.minimizeRecap,
              maximize: _vm.maximizeRecap,
              close: _vm.removeRecap,
              edit: _vm.editPost,
            },
          })
        : _vm._e(),
      _c(
        "vs-popup",
        {
          staticClass: "exportPopup",
          attrs: {
            title: `${_vm.$t("dash.posts.export_popuptitle")} (Beta)`,
            active: _vm.popupExport,
          },
          on: {
            "update:active": function ($event) {
              _vm.popupExport = $event
            },
          },
        },
        [
          _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
            _vm._v(_vm._s(_vm.$t("dash.posts.export_description"))),
          ]),
          _c(
            "div",
            { staticClass: "export-date" },
            [
              _c("component-datepicker", {
                staticClass: "date",
                attrs: {
                  from: this.disabledDate.from,
                  to: this.disabledDate.to,
                  date: _vm.dateStart,
                },
                on: { picked: _vm.setDateStart },
              }),
              _c("component-datepicker", {
                staticClass: "date",
                attrs: {
                  from: this.disabledDate.from,
                  to: this.disabledDate.to,
                  date: _vm.dateEnd,
                },
                on: { picked: _vm.setDateEnd },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "actions-wrapper export" }, [
            _c("div", { staticClass: "filters-wrapper export" }, [
              _c(
                "div",
                {
                  staticClass: "filterExport",
                  class: { active: _vm.filterExport.includes("all") },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filterExport,
                        expression: "filterExport",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "content2",
                      value: "all",
                      disabled: _vm.filterExport.includes("all"),
                    },
                    domProps: {
                      checked: Array.isArray(_vm.filterExport)
                        ? _vm._i(_vm.filterExport, "all") > -1
                        : _vm.filterExport,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.filterExport,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "all",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.filterExport = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.filterExport = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.filterExport = $$c
                          }
                        },
                        function ($event) {
                          ;[
                            (_vm.filterExport = ["all"]),
                            _vm.arrayPostsFilter(true),
                          ]
                        },
                      ],
                    },
                  }),
                  _c("div", { staticClass: "filter-content" }, [
                    _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.status.all")))]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "filterExport",
                  class: { active: _vm.filterExport.includes("queue") },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filterExport,
                        expression: "filterExport",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "content2",
                      value: "queue",
                      disabled:
                        _vm.filter.length == 1 && _vm.filter.includes("queue"),
                    },
                    domProps: {
                      checked: Array.isArray(_vm.filterExport)
                        ? _vm._i(_vm.filterExport, "queue") > -1
                        : _vm.filterExport,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.filterExport,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "queue",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.filterExport = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.filterExport = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.filterExport = $$c
                          }
                        },
                        function ($event) {
                          ;[
                            (_vm.filterExport = _vm.filterExport.filter(
                              (f) => f != "all"
                            )),
                            _vm.arrayPostsFilter(true),
                          ]
                        },
                      ],
                    },
                  }),
                  _c("div", { staticClass: "filter-content" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.posts.status.inqueue"))),
                    ]),
                    _c("img", {
                      staticClass: "icon-grey",
                      attrs: {
                        src: require("../../../assets/img/icon_wait_grey.svg"),
                        alt: "queue",
                      },
                    }),
                    _c("img", {
                      staticClass: "icon-white",
                      attrs: {
                        src: require("../../../assets/img/icon_wait_white.svg"),
                        alt: "queue",
                      },
                    }),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "filterExport",
                  class: { active: _vm.filterExport.includes("scheduled") },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filterExport,
                        expression: "filterExport",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "content2",
                      value: "scheduled",
                      disabled:
                        _vm.filter.length == 1 &&
                        _vm.filter.includes("scheduled"),
                    },
                    domProps: {
                      checked: Array.isArray(_vm.filterExport)
                        ? _vm._i(_vm.filterExport, "scheduled") > -1
                        : _vm.filterExport,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.filterExport,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "scheduled",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.filterExport = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.filterExport = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.filterExport = $$c
                          }
                        },
                        function ($event) {
                          ;[
                            (_vm.filterExport = _vm.filterExport.filter(
                              (f) => f != "all"
                            )),
                            _vm.arrayPostsFilter(true),
                          ]
                        },
                      ],
                    },
                  }),
                  _c("div", { staticClass: "filter-content" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.posts.status.scheduled"))),
                    ]),
                    _c("img", {
                      staticClass: "icon-grey",
                      attrs: {
                        src: require("../../../assets/img/icon_time_grey.svg"),
                        alt: "scheduled",
                      },
                    }),
                    _c("img", {
                      staticClass: "icon-white",
                      attrs: {
                        src: require("../../../assets/img/icon_time_white.svg"),
                        alt: "scheduled",
                      },
                    }),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "filterExport",
                  class: { active: _vm.filterExport.includes("posted") },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filterExport,
                        expression: "filterExport",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "content2",
                      value: "posted",
                      disabled:
                        _vm.filter.length == 1 && _vm.filter.includes("posted"),
                    },
                    domProps: {
                      checked: Array.isArray(_vm.filterExport)
                        ? _vm._i(_vm.filterExport, "posted") > -1
                        : _vm.filterExport,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.filterExport,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "posted",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.filterExport = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.filterExport = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.filterExport = $$c
                          }
                        },
                        function ($event) {
                          ;[
                            (_vm.filterExport = _vm.filterExport.filter(
                              (f) => f != "all"
                            )),
                            _vm.arrayPostsFilter(true),
                          ]
                        },
                      ],
                    },
                  }),
                  _c("div", { staticClass: "filter-content" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.posts.status.posted"))),
                    ]),
                    _c("img", {
                      staticClass: "icon-grey",
                      attrs: {
                        src: require("../../../assets/img/icon_check_grey.svg"),
                        alt: "posted",
                      },
                    }),
                    _c("img", {
                      staticClass: "icon-white",
                      attrs: {
                        src: require("../../../assets/img/icon_check_white.svg"),
                        alt: "posted",
                      },
                    }),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "filterExport",
                  class: { active: _vm.filterExport.includes("failed") },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filterExport,
                        expression: "filterExport",
                      },
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "content2",
                      value: "failed",
                      disabled:
                        _vm.filter.length == 1 && _vm.filter.includes("failed"),
                    },
                    domProps: {
                      checked: Array.isArray(_vm.filterExport)
                        ? _vm._i(_vm.filterExport, "failed") > -1
                        : _vm.filterExport,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.filterExport,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "failed",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.filterExport = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.filterExport = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.filterExport = $$c
                          }
                        },
                        function ($event) {
                          ;[
                            (_vm.filterExport = _vm.filterExport.filter(
                              (f) => f != "all"
                            )),
                            _vm.arrayPostsFilter(true),
                          ]
                        },
                      ],
                    },
                  }),
                  _c("div", { staticClass: "filter-content" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dash.posts.status.failed"))),
                    ]),
                    _c("img", {
                      staticClass: "icon-grey",
                      attrs: {
                        src: require("../../../assets/img/icon_check_grey.svg"),
                        alt: "failed",
                      },
                    }),
                    _c("img", {
                      staticClass: "icon-white",
                      attrs: {
                        src: require("../../../assets/img/icon_check_white.svg"),
                        alt: "failed",
                      },
                    }),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm.postsToExport.length > 0
            ? _c(
                "vs-button",
                {
                  staticClass: "exportBtn",
                  attrs: { "vs-type": "filled" },
                  on: {
                    click: function ($event) {
                      return _vm.exportData()
                    },
                  },
                },
                [
                  _c("p", [
                    _vm._v(
                      "Export (" + _vm._s(this.postsToExport.length) + ")"
                    ),
                  ]),
                ]
              )
            : _c(
                "vs-button",
                { staticClass: "exportBtn", attrs: { disabled: "" } },
                [_c("p", [_vm._v("Export (0)")])]
              ),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          staticClass: "importPopup",
          attrs: {
            title: `${_vm.$t("dash.posts.import_popuptitle")} (Beta)`,
            active: _vm.popupImport,
          },
          on: {
            "update:active": function ($event) {
              _vm.popupImport = $event
            },
          },
        },
        [
          _c("div", { staticClass: "importcsv-popup" }, [
            _c(
              "div",
              {
                attrs: { id: "box" },
                on: {
                  drop: function ($event) {
                    ;[_vm.drop($event), _vm.loadCSV($event)]
                  },
                },
              },
              [
                _c("img", {
                  staticStyle: {
                    height: "80px",
                    width: "80px",
                    opacity: "0.2",
                    margin: "10px",
                  },
                  attrs: {
                    src: require("../../../assets/img/csv.svg"),
                    alt: "search",
                  },
                }),
                _c("input", {
                  ref: "file",
                  attrs: { type: "file", id: "file", accept: ".csv" },
                  on: {
                    change: function ($event) {
                      ;[_vm.onChange(), _vm.loadCSV($event)]
                    },
                  },
                }),
                _c("label", { attrs: { id: "labelImport" } }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("dash.posts.import_dragdrop")) +
                      "\n          "
                  ),
                ]),
                this.fileInput.length && _vm.isCSV(this.fileInput)
                  ? _c(
                      "ul",
                      { staticStyle: { margin: "5px" } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.fileInput[0].name) +
                            "\n              "
                        ),
                        _c(
                          "vs-button",
                          {
                            staticStyle: { margin: "5px", opacity: "0.7" },
                            attrs: {
                              size: "small",
                              title: _vm.$t("dash.posts.import_remove"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.remove(_vm.fileInput)
                              },
                            },
                          },
                          [_vm._v("\n                x")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              { attrs: { id: "updateBtn" } },
              [
                _vm.fileInputParesed.length != 0
                  ? _c(
                      "vs-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.multipleSchedules()
                          },
                        },
                      },
                      [_vm._v("Update")]
                    )
                  : _c("vs-button", { attrs: { disabled: "" } }, [
                      _vm._v("Update"),
                    ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }